import { LiveEndpointKeys } from './liveTypes'

import { Visibility } from 'modules/transmission/types'
import Settings from 'common/helpers/settings'

export const LiveEndpoints = {
  [LiveEndpointKeys.getLive]: (transmissionCode: string, visibility: Visibility) => {
    const endpointByVisibility: { [key in Visibility]?: string } = {
      [Visibility.PUBLIC]: `public/schedule/${transmissionCode}`,
      [Visibility.PRIVATE]: `schedule/${transmissionCode}/private`,
      [Visibility.HOTMART]: `schedule/${transmissionCode}/private/hotmart`
    }
    const url = endpointByVisibility[visibility] || endpointByVisibility.PUBLIC

    return `${Settings.api.live}/v1/${url}`
  }
}
